<template>
    <div class="">
        <div class="custom-loader-wrapper" v-if="loader">
            <div class="text-center">
                <span class="d-block max-450">We are processing your download and this may take some time. Do not close this window until the download begins.</span>
                <img v-bind:src="$api_url+'/images/download-loader.svg'" class="loader-logo" width="100px"/>
                <p class="mt-5">Plesae click <a target="_blank" :href="pageurl">here</a> or below if you want to continue surfing the system.</p>
                <b-button  class="mb-1"  target="_blank"  :href="pageurl">Dashboard</b-button>
                            
            </div> 
        </div>
            {{ clickAccept }}
        <div class="row no-gutters py-2 mb-3 ml-3"> <!-- Mustafijur: 24-06-2026: removed border-bottom-->
			<div class="col-sm-6 pr-3 ">
				<h4 class="atlhr-dashboard-title mt-10">
					<span class="blue-title">PF</span> Advance
					<span>
						<a v-bind:href="pageurl">Dashboard</a>
						/ PF Advance
					</span>
				</h4>
			</div>
		</div>
        <div class="row col-12 no-margin">
            <div class="ibox col-md-12 border-0">
                <div class="ibox-title dashboard_title company-form-box-title">
                    <h4 class="clearfix">
                        <span class="float-left">Advance Summary
 
                            <span class="title-sub-text">A comprehensive overview of an employee's provident fund loan account.</span></span>
                        <span class="float-right">
                            <b-button v-if="loans.length > 0 && (employee_id != '' || employee_id != null) " class="mr-2 mt-2" @click="showStatementDownloadForm()">
                                Download Statement
                            </b-button>
                            <button v-if="is_eligible==1" class="btn btn-block btn-secondary tab-button mt-2"  @click="addNewLoan()" > Apply For Advance </button>
                        </span>
                    </h4>
                </div>
                <div class="ibox-content">
                    <b-overlay :show="showoverlay_list" rounded="sm">
                        <div v-if="loans.length > 0" class="">    
                            <table class="table employee-list-table"><!-- Mustafijur: 24-08-2026 -->
                                <thead>
                                    <tr class=" table-head" style="font-size: 16px;">
                                        <td class="col-sm-2 font-weight-bold py-2">
                                            Advance ID
                                        </td>                       
                                        <td class="col-sm-2 font-weight-bold py-2 text-center">
                                            Amount
                                        </td>
                                        <td class="col-sm-2 font-weight-bold py-2">
                                            Deduction Start Month
                                        </td>
                                        <td class="col-sm-2 font-weight-bold py-2">
                                            Effective Date
                                        </td>
                                        <td class="col-sm-2 font-weight-bold py-2">
                                            Tenure
                                        </td>
                                        <td class="col-sm-1 font-weight-bold py-2">
                                            Status
                                        </td>
                                        <td class="col-sm-1 font-weight-bold py-2 text-center"  v-if="flg > 0">    
                                            Actions                              
                                        </td>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr class="table-row" v-for="loan in loans" :key="loan.id">
                                        
                                        <td class="" v-if="loan.company_loan_id != 'N/A'">{{loan.company_loan_id}}</td>
                                        <td class="" v-else>Not assigned yet</td>
                                        
                                        <td class="text-right">
                                            {{formatMoney(loan.loan_amount)}}
                                        </td>
                                        <td class="">
                                            {{loan.deduction_start_month}}
                                        </td>
                                        <td class="">
                                            {{loan.effective_date_of_loan}}
                                        </td>
                                        
                                        <td class="text-center">
                                            {{loan.loan_tenure}} Month(s)
                                        </td>
                                        <!-- Mustafijur: 24-06-2026: Start -->
                                        <td class="py-1 " :class="(loan.loan_application_status != '' && loan.loan_application_status != 'Approved') ? loan.loan_application_status.toLowerCase() : loan_stat_title_2[loan.status].toLowerCase()">
                                            <div class="leave-status">
                                                <i class="fa fa-circle mr-1"></i>
                                                <template v-if="loan.loan_application_status !='' && loan.loan_application_status !='Approved'">
                                                    {{loan.loan_application_status}}
                                                </template>
                                                <template v-else>
                                                    {{loan_stat_title_2[loan.status]}}
                                                </template>
                                            </div>
                                        </td>
                                        <!-- Mustafijur: 24-06-2026: End -->
                                        <td class=" clearfix py-2 text-right position-relative justify-content-center"  v-if="flg > 0"> 
                                            <a id="actionDropdown" class="dropdown-toggle clearfix action-dropdown-toggle" style="font-size: 16px;" href="#" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><b-icon icon="three-dots-vertical"></b-icon></a>                               
                                            <div class="dropdown-menu action-dropdown-menu py-0" aria-labelledby="actionDropdown">
                                                <b-button-toolbar class="custom-btn-toolbar">
                                                    <b-button-group class="d-flex flex-column flex-grow-1">
                                                        <b-button class="border-0 rounded mb-1" variant="outline-secondary" v-if="loan_stat_title[loan.status] == 'Applied' "  :title="loan.approvals == 1 ? 'Details' : 'Edit'" @click="editLoanInfo(loan.id,loan.employee_name,0,0)">
                                                        <template v-if="loan.approvals == 1">
                                                                <i class="fas fa-edit"></i>Details
                                                        </template>
                                                        <template v-else>
                                                                <i class="fas fa-edit"></i>Edit
                                                        </template>
                                                        
                                                        </b-button>
                                                        <!-- <b-button class="border-0 rounded mb-1" variant="outline-secondary" v-if="loan_stat_title[loan.status] == 'Applied'"  title="Edit Bank Account Info" @click="editLoanInfoOld(loan.id,loan.employee_name,0,0)">
                                                            <i class="fas fa-edit"></i>Edit Old
                                                        </b-button> -->
                                                        <b-button class="border-0 rounded mb-1"  v-if="loan.has_tx==0  && (loan_stat_title[loan.status] == 'Applied') && loan.approvals != 1" variant="outline-secondary" title="Edit Bank Account Info" @click="showDeleteModal(loan.id)">
                                                            <i class="fas fa-trash"></i>  Delete <!-- Mustafijur: 24-06-2026: fa-times to fa-trash -->
                                                        </b-button>
                                                        <b-button class="border-0 rounded mb-1"  v-if="loan_stat_title[loan.status] == 'Applied' && loan.approvals == 1" variant="outline-secondary" title="Edit Bank Account Info" @click="showWithdrawModal(loan.id)"> 
                                                            <i class="fas fa-times"></i>  Withdraw
                                                        </b-button> 
                                                        <b-button class="border-0 rounded mb-1"  v-if="loan_stat_title[loan.status] == 'Approved' || loan_stat_title[loan.status] == 'Pause/Stopped' || loan_stat_title[loan.status] == 'Returned'" variant="outline-secondary" title="Installments" @click="showInstallment(loan.id)"> 
                                                            <i class="fab fa-delicious"></i> Installments
                                                        </b-button>
                                                        <b-button class="border-0 rounded mb-1" variant="outline-secondary"  v-if="loan_stat_title[loan.status] != 'Applied' && loan_stat_title[loan.status] != 'Declined' && loan_stat_title[loan.status] != 'Withdrawn' " title="Transactions" @click="showLoanTransactions(loan.id)"> 
                                                            <i class="fas fa-table"></i> Transactions
                                                        </b-button>

                                                        <b-button class="border-0 rounded mb-1" variant="outline-secondary"  v-if="loan_stat_title[loan.status] != 'Applied' && loan_stat_title[loan.status] != 'Declined' && loan_stat_title[loan.status] != 'Withdrawn'" title="Preview Advance Schedule" @click="loanScheduleDetailsNew(loan)"> 
                                                            <i class="fas fa-list"> </i> Preview Advance Schedule
                                                        </b-button>
                                                        <b-button class="border-0 rounded mb-1" variant="outline-secondary"  v-if="loan_stat_title[loan.status] != 'Applied' && loan_stat_title[loan.status] != 'Declined' && loan_stat_title[loan.status] != 'Withdrawn'" title="Download Advance Schedule" @click="getloanScheduleReport(loan)"> 
                                                            <i class="far fa-file-excel"> </i> Download Advance Schedule
                                                        </b-button>

                                                        <!-- Start: Rejwan: 08-04-2026 Early loan settlement -->
                                                        <b-button class="border-0 rounded mb-1" variant="outline-secondary"  v-if="loan_stat_title_2[loan.status] == 'Open'" title="Early Settlement" @click="earlySettlementDetails(loan.id,loan.employee_name,0,0)"> 
                                                            <i class="fas fa-list"> </i> Early Settlement
                                                        </b-button>
                                                        <!-- End: Rejwan: 08-04-2026 Early loan settlement -->
                                                    </b-button-group>
                                                </b-button-toolbar>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody> 
                            </table>                                    
                        </div>
                        <div v-else class=" p-4">  
                            
                            <div v-if="show_loader" class="list-no-data">
                                <span class="d-block text-center">Looking for relevant data..</span>
                                <img v-bind:src="$api_url+'/images/download-loader.svg'" class="loader-logo" width="100px"/>
                            </div>
                            <div v-else class="list-no-data">
                                Sorry no loan to show. 
                            </div>
                        </div>
                    </b-overlay>
                </div>
            </div>
        </div>
        <b-modal id="decline-modal" title="Are you sure you want to decline this Advance ?" hide-footer> 
            <br />
            <div style="height: 10px;clear:both;"> &nbsp;</div>
            <a href="javascript:void(0);" class="btn btn-primary btn-full-width"  @click="pauseLoan(loan_entity_id)">Decline <span v-if="loading != ''"><img :src="this.$api_url+'/images/loading.gif'" width="20"></span></a>
            &nbsp;&nbsp; <a href="javascript:void(0);" class="btn btn-primary btn-full-width" block @click="$bvModal.hide('decline-modal')">Cancel</a>
            <div style="height: 5px;clear:both;"> &nbsp;</div>
        </b-modal>

        <b-modal id="delete-modal" title="Are you sure you want to delete this Advance ?" hide-footer> 
            <br />
            <div style="height: 10px;clear:both;"> &nbsp;</div>
            <a href="javascript:void(0);" class="btn btn-primary btn-full-width"  @click="deleteLoan(loan_entity_id)">Delete <span v-if="loading != ''"><img :src="this.$api_url+'/images/loading.gif'" width="20"></span></a>
            &nbsp;&nbsp; <a href="javascript:void(0);" class="btn btn-primary btn-full-width" block @click="$bvModal.hide('delete-modal')">Cancel</a>
            <div style="height: 5px;clear:both;"> &nbsp;</div>
        </b-modal>

        <b-modal id="withdraw-modal" title="Are you sure you want to withdraw this Advance ?" hide-footer> 
            <br />
            <div style="height: 10px;clear:both;"> &nbsp;</div>
            <a href="javascript:void(0);" class="btn btn-primary btn-full-width"  @click="withdrawLoan(loan_entity_id)">Withdraw <span v-if="loading != ''"><img :src="this.$api_url+'/images/loading.gif'" width="20"></span></a>
            &nbsp;&nbsp; <a href="javascript:void(0);" class="btn btn-primary btn-full-width" block @click="$bvModal.hide('withdraw-modal')">Cancel</a>
            <div style="height: 5px;clear:both;"> &nbsp;</div>
        </b-modal>

        <b-modal id="unapprove-modal" title="Are you sure you want to unapprove this Advance ?" hide-footer> 
            <br />
            <div style="height: 10px;clear:both;"> &nbsp;</div>
            <a href="javascript:void(0);" class="btn btn-primary btn-full-width"  @click="pauseLoan(loan_entity_id)">Unapprove <span v-if="loading != ''"><img :src="this.$api_url+'/images/loading.gif'" width="20"></span></a>
            &nbsp;&nbsp; <a href="javascript:void(0);" class="btn btn-primary btn-full-width" block @click="$bvModal.hide('unapprove-modal')">Cancel</a>
            <div style="height: 5px;clear:both;"> &nbsp;</div>
        </b-modal>

        <b-modal id="bv-modal-loan-2" size="lg" hide-footer v-bind:title="modal_title">
            <pf-loan-form-front :pageurl="this.$api_url" :flg="flg" :employee_id="employee_id" :key="count" :count="count" :loan_id="loan_id" :is_custom="is_custom" :is_status="is_status" v-on:childToParent="updateLoanData"></pf-loan-form-front>
        </b-modal>

        <b-modal id="bv-modal-loan" size="lg" hide-footer v-bind:title="modal_title" dialog-class="w-1200" :modal-class="pf_loan_modal_class">
            <!-- <pf-loan-form-front-new :pageurl="this.$api_url" :flg="flg" :employee_id="employee_id" :employee_name="curr_process_name" :key="count" :count="count" :loan_id="loan_id" :is_custom="is_custom" :is_status="is_status" :is_self="is_self" v-on:childToParent="updateLoanData"></pf-loan-form-front-new> -->
            <pf-loan-form-front-new-front :pageurl="this.$api_url" :flg="flg" :employee_id="employee_id" :employee_name="curr_process_name" :key="count" :count="count" :loan_id="loan_id" :is_custom="is_custom" :is_status="is_status" :is_self="is_self" v-on:childToParent="updateLoanData"></pf-loan-form-front-new-front>
        </b-modal>
        <b-modal id="bv-modal-pf-loan-transactions-wizard" size="lg" hide-footer title="Advance Breakdown">
            <!-- <pf-loan-transactions-wizard-front :pageurl="this.$api_url" :employee_id="employee_id" :key="tx_popup_count" :loan_id="loan_id" :is_front="is_front"></pf-loan-transactions-wizard-front>                   -->
            <pf-loan-transactions-wizard-front-new :pageurl="this.$api_url" :employee_id="employee_id" :key="tx_popup_count" :loan_id="loan_id" :is_front="is_front" :is_self="is_self"></pf-loan-transactions-wizard-front-new>   
        </b-modal> 

        <b-modal id="installment-modal" title="Installment Breakdown" hide-footer> 
        <div class="row table-head mx-0"> <!-- Mustafijur: 23-08-2026 -->
            <div class="col-sm-4 font-weight-bold py-2">
                Installment No.
            </div>                      
            <div class="col-sm-4 font-weight-bold py-2">
                Month
            </div>
            <div class="col-sm-4 font-weight-bold py-2">
                Amount
            </div>
        </div>
        <div class="row table-row hover-bg mx-0"  v-for="(row, index) in my_installments" :key="index"> <!-- Mustafijur: 23-08-2026 -->
            <div class="col-sm-4 py-2 align-items-center d-flex">                    
                <div :style="(row.status==3) ? styleA : styleB" ><template v-if="(row.installment_type==0)">Installment #{{index+1}}</template><template v-else>Service Charge</template></div>
            </div>
            <div class="col-sm-4 py-2 align-items-center d-flex" v-bind:style="[(row.status==3) ? {styleA} : {styleB}]">                    
                <div :style="(row.status==3) ? styleA : styleB">{{row.month}}</div>
            </div>
            <div class="col-sm-4 py-2 align-items-center d-flex" v-bind:style="[(row.status==3) ? {styleA} : {styleB}]">
                <div :style="(row.status==3) ? styleA : styleB">{{row.amount}}</div>
            </div>
        </div>
            <br />
            <div style="height: 10px;clear:both;"> &nbsp;</div>
            &nbsp;&nbsp; <a href="javascript:void(0);" class="btn btn-primary btn-full-width" block @click="$bvModal.hide('installment-modal')">Close</a>
            <div style="height: 5px;clear:both;"> &nbsp;</div>
        </b-modal>

        <b-modal  id="bv-modal-pf-loan-schedule-details" hide-footer  title="Advance Schedule Details" size="lg">
            <b-overlay rounded="sm">
                <div class="row col-12 no-margin px-0">
                    <template v-if="installments.length == 0">
                        <div class="px-3 py-3 no-result-cell text-center col-12">
                            <span class="d-block text-center">{{empty_result}}</span>
                            <img v-bind:src="$api_url+'/images/download-loader.svg'" class="loader-logo" width="100px"/>
                        </div>
                    </template>
                    <template  v-else>
                        <!--<div class="clearfix border rounded mt-3  py-2 mb-2 mr-3 mb-0 col-md-12">
                            <div class="row justify-content-center">{{report_data.company_name}}</div>
                            <div class="row justify-content-center">{{report_data.title}}</div>
                        </div>-->
                        <div class="ibox col-md-12 no-shadow border">
                            <div class="ibox-title dashboard_title">
                                <h4 class="clearfix">
                                    <span class="float-left">Advance Information</span>
                                    <span class="float-right"></span>
                                </h4>
                            </div>
                            <div class="ibox-content pf-overview">
                                <div class="row">
                                    <div class="col-lg-6 col-md-6 col-sm-12">
                                        <div class="row">
                                            <div class="col-lg-6 col-md-6 col-sm-12"><h3>Employee Name</h3></div>
                                            <div class="col-lg-6 col-md-6 col-sm-12"><span>{{employee_info.employee_name}}</span></div>
                                        </div>
                                        <div class="row">
                                            <div class="col-lg-6 col-md-6 col-sm-12"><h3>Employee Code</h3></div>
                                            <div class="col-lg-6 col-md-6 col-sm-12"><span>{{employee_info.employee_code}}</span></div>
                                        </div>
                                        <div class="row">
                                            <div class="col-lg-6 col-md-6 col-sm-12"><h3>Advance Amount</h3></div>
                                            <div class="col-lg-6 col-md-6 col-sm-12"><span>{{formatMoney(employee_info.loan_amount)}}</span></div>
                                        </div>
                                    </div>
                                    <div class="col-lg-6 col-md-6 col-sm-12">
                                        <div class="row">
                                            <div class="col-lg-6 col-md-6 col-sm-12"><h3>Job Position</h3></div>
                                            <div class="col-lg-6 col-md-6 col-sm-12"><span>{{employee_info.jobposition}}</span></div>
                                        </div>
                                        <div class="row">
                                            <div class="col-lg-6 col-md-6 col-sm-12"><h3>Department</h3></div>
                                            <div class="col-lg-6 col-md-6 col-sm-12"><span>{{employee_info.department}}</span></div>                                       
                                        </div>
                                        <div class="row">
                                            <div class="col-lg-6 col-md-6 col-sm-12"><h3>Repayment Tenure</h3></div>
                                            <div class="col-lg-6 col-md-6 col-sm-12"><span>{{employee_info.repayment_tenure}}</span></div>                                        
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="ibox col-md-12 ibox col-md-12 border-0">
                            <div class="ibox-title dashboard_title">
                                <h4 class="clearfix">
                                    <span class="float-left">Installments</span>
                                    <span class="float-right"></span>
                                </h4>
                            </div>
                            <div v-if="installments.length > 0" class="ibox-content">
                                <table class="table "> 
                                    <thead class="" style="">
                                        <tr class="table-head"  v-for="(detail, index) in installments" :key="detail.month">
                                            <template v-if="index < 1">
                                                <template v-for="(v,i,count) in detail">
                                                    <td class="2 text-center" v-if="i == 'SN.' || i== 'month'  ">{{ replaceTableHeads(i) }}</td> <!-- Mustafijur: 23-08-2026 -->
                                                    <td class="text-center" v-else>{{ replaceTableHeads(i) }}</td>
                                                </template>
                                            </template>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr style="display: none;"></tr>
                                        <tr class="table-row" v-for="detail in installments" :key="detail.month">
                                            <!--aboni 10-11-21-->
                                            <template v-for="(v,i,count) in detail">
                                                <td class="2" :class="i == 'SN.' ? 'text-center' : 'text-left'" v-if="i == 'SN.' || i== 'month'  ">{{v}} </td> <!-- Mustafijur: 23-08-2026 -->
                                                <td class="2 text-center" v-else-if=" i== 'status'  ">{{status[v]}} </td>
                                                <td v-else   class="2 text-right" ><div v-if="v==0">--</div><div v-else>{{formatMoney(v)}}</div></td>

                                            </template>
                                            <!--aboni 10-11-21-->
                                            
                                            
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                            <div v-if="installments.length == 0" class="ibox-content text-center">
                                <span class="d-block text-center">No Installment available</span>                            
                            </div>
                        </div>


                        <div class="ibox col-md-12 ibox col-md-12 border-0">
                            <div class="ibox-title dashboard_title">
                                <h4 class="clearfix">
                                    <span class="float-left">Transactions</span>
                                    <span class="float-right"></span>
                                </h4>
                            </div>
                            <div v-if="transactions.length > 0" class="ibox-content">
                                <table class="table "> 
                                    <thead class="" style="">
                                        <tr class="table-head"  v-for="(detail, index) in transactions" :key="detail.month">
                                            <template v-if="index < 1">
                                                <template v-for="(v,i,count) in detail">
                                                    <td class="2 text-center" v-if="i == 'SN.' || i== 'month'  ">{{ replaceTableHeads(i) }}</td> <!-- Mustafijur: 23-08-2026 -->
                                                    <td class="text-center" v-else>{{ replaceTableHeads(i) }}</td>
                                                </template>
                                            </template>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr style="display: none;"></tr>
                                        <tr class="table-row" v-for="detail in transactions" :key="detail.month">
                                            <!--aboni 10-11-21-->
                                            <template v-for="(v,i,count) in detail">
                                                <td class="2" :class="i == 'SN.' ? 'text-center' : 'text-left'" v-if="i == 'SN.' || i== 'month'  ">{{v}} </td> <!-- Mustafijur: 23-08-2026 -->
                                                <td v-else   class="2 text-right" ><div v-if="v==0">--</div><div v-else>{{formatMoney(v)}}</div></td>

                                            </template>
                                            <!--aboni 10-11-21-->
                                            
                                            
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div v-if="transactions.length == 0" class="ibox-content no-result-cell text-center">
                                <span class="d-block text-center">No Transaction available</span>
                            </div>
                        </div>
                    </template>
                </div>
            </b-overlay>
        </b-modal>

        <b-modal id="show_terms" size="lg" hide-footer title="Terms and Conditions for PF Advance" scrollable>
            <!-- <pf-loan-terms :pageurl="this.$api_url" :terms="pf_loan_term_agreement" :key="ag_key"></pf-loan-terms> -->
            <pf-loan-terms-front :pageurl="this.$api_url" :terms="pf_loan_term_agreement" :key="ag_key"></pf-loan-terms-front> 
            
            <div class="row mt-4">
                <div class="d-flex justify-content-start col-6">
                 
                    <b-form-checkbox v-model="accept" value="true" unchecked-value="false">
                        I accept the terms and use conditions
                    </b-form-checkbox>  
                </div> 
                <div class="d-flex justify-content-end mt-2 col-6">
                    <b-form-group id="login-submit-group">
                        
                        <b-button :disabled="disableme" type="button" variant="primary" class="" @click="addNew()">Agree & Proceed</b-button>
                    </b-form-group>
                </div>
            </div>
            
        </b-modal>
        <template v-if="employee_id > 0">  
            <b-modal id="bv-modal-process-statement" size="md" hide-footer  title="Download PF Advance Statement">
                <!-- <pf-loan-statement-download-form :employee_id="employee_id" :key="waiver_key" :pageurl="pageurl" :store_scope="store_scope"  v-on:childToParent="statementReturn"></pf-loan-statement-download-form> -->
                <pf-loan-statement-download-form-front :employee_id="employee_id" :key="waiver_key" :pageurl="$api_url" :store_scope="store_scope"  v-on:childToParent="statementReturn"></pf-loan-statement-download-form-front>
            </b-modal> 
        </template>

        <!-- Start: Rejwan: 08-04-2026 Early loan settlement -->
        <b-modal id="bv-modal-loan-early-settlement" size="lg" hide-footer v-bind:title="modal_title"  :modal-class="pf_loan_modal_class">
            <pf-loan-early-settlement-form-front :flg="flg" :employee_id="employee_id" :employee_name="curr_process_name" :key="count" :count="count" :loan_id="loan_id" :is_self="is_self" v-on:childToParent="handleEarlySettlement"></pf-loan-early-settlement-form-front>
        </b-modal>
        <!-- End: Rejwan: 08-04-2026 Early loan settlement -->
        
    </div>
</template> 

 
<script>
    export default{
        
        mounted() {
             
        },
        props: ['pageurl','bn' ,'flg','employee_id'],
        data(){            
            
            return {
                
                accept:false,
                loans:[],
                pf_settings:[],
                successmsg:'',
                styleA: 'color:#55ce63 !important',
                styleB: 'color:#212529 !important',
                is_status:'',
                loan_stat_title: ["Declined","Applied","Approved","Pause/Stopped","Returned","","","","Withdrawn"],
                loan_stat_title_2: ["Declined","Applied","Open","Pause/Stopped","Closed","","","","Withdrawn"],
                loan_stat_div: ["text-danger","text-info","text-success","text-muted","text-purple"],
                default_tenure: [0,12,1],
                curr_process_name: '',
                curr_process_id:'',
                e_name:'',
                e_id:'',
                pf_loan_term_agreement:'',
                showoverlay_list : false,         
                disable_submit :false,             
                successmsg:'',
                show_loader:true,
                errormsg:[],
                selected_bank_id:0,
                loading:'',
                loan_title:'',
                amount_title: '',
                showoverlaymodal : false,
                loan_entity_id:'',
                loan_update_status:'',
                loan_type: 1,
                loan_id :0,
                tx_popup_count:0,
                modal_title:"",
                is_custom:0,
                my_installments:[],
                installments:[],
                empty_result : 'Fetching Data!',
                is_front :1,
                loader: false,
                pf_agreement:'',
                ag_key:0,
                disableme:true,
                count:0, 
                loan_types_drop : ['','Loan','Advance'],
                status:['--','','Paused/Stopped','Paid'],
                loan_status:[
                    { value: null, text: "Select..." },
                    { value: "0", text: "Decline" },
                    { value: "1", text: "Applied" },
                    { value: "2", text: "Approve" },
                    { value: "3", text: "Pause/Stop" },
                ],
                loan_type_vals:[
                    { value: "1", text: "Loan" }, 
                    { value: "2", text: "Advance" },

                ],
                m_lists : [],
                is_eligible:1,
                pf_loan_modal_class:'',
                is_self:1,
                waiver_key:0,
            }
        },
        methods:{
            
            addNewLoan: function()
            {
                this.accept = false;
                if(this.pf_settings.pf_enable_term_agreement.opt_value == 1)
                {
                    this.$bvModal.show('show_terms');
                }
                else
                {
                    this.addNew();
                }
                
            },
            addNewLoanOld: function()
            {
                this.addNewOld();
                
            },

            showUnApproveModal: function(pageflg)
            {
            this.loan_entity_id=pageflg;
            this.loan_update_status = 1;
            this.$bvModal.show('unapprove-modal');
            },
            showDeclineModal: function(pageflg)
            {
            this.loan_entity_id=pageflg;
            this.loan_update_status = 0;
            this.$bvModal.show('decline-modal');
            },
            showDeleteModal: function(pageflg)
            {
            this.loan_entity_id=pageflg;
            this.$bvModal.show('delete-modal');
            },
            showWithdrawModal: function(pageflg)
            {
            this.loan_entity_id=pageflg;
            this.$bvModal.show('withdraw-modal');
            },
            showInstallment: function(loan)
            {
                if(!this.checkNet()) return false;
                let currentObj = this; 
                let formData = new FormData();
                formData.append('loan_id', loan);   
                this.my_installments = [];
                this.showoverlay = true;
                axios.post(this.$api_url_front+'/self/pf/loan/installments', formData)
                .then(function (response) 
                {
                    this.my_installments = response.data;
                    this.showoverlay = false;
                    this.$bvModal.show('installment-modal');
                        
                }.bind(this)).catch(function (error){currentObj.serverError(error);});

            },
            showLoanTransactions: function(loan_id,employee_id)
            { 
                this.loan_id = loan_id;
                this.employee_id = employee_id;
                this.tx_popup_count = this.tx_popup_count + 1;
                this.$bvModal.show('bv-modal-pf-loan-transactions-wizard');
            },
            getPFSettings: function()
            { 
                
                let currentObj = this;
                axios.get(this.$api_url_front+'/pf/settings').then(function (response) {
                    currentObj.pf_settings = response.data.data;
                    currentObj.pf_loan_term_agreement = currentObj.pf_settings.pf_loan_term_agreement.opt_value_serialized;
                    currentObj.ag_key += 1;
                        
                })  
                .catch(function (error) {
                console.log(error);
                });
                
            },
            pauseLoan: function(pageflg)
            {
                
                this.loading='load';
                var update_status = this.loan_update_status;
                let formData = new FormData();
                formData.append('loan_id', pageflg); 
                formData.append('status', update_status); 
                axios.post(this.$api_url+'/pf/loan/loan-update-status', formData) 
                    .then(function (response) 
                    {    
                        this.$bvModal.hide('pause-modal'); 
                        this.$bvModal.hide('approve-modal');  
                        this.$bvModal.hide('decline-modal'); 
                        this.$bvModal.hide('unapprove-modal');
                        this.$bvModal.hide('delete-modal');
                        this.$bvModal.hide('withdraw-modal');
                        

                        this.loan_entity_id=''; 
                        this.loan_update_status = '';
                        this.loading='';   
                        this.updateLoanData();
                    }.bind(this))
                    .catch(function (error) 
                    {
                        currentObj.showoverlay = false;
                        currentObj.serverError(error);
                    });
                            
            },
            deleteLoan: function(pageflg)
            {
                
                this.loading='load';
                let currentObj = this; 
                let formData = new FormData();
                formData.append('loan_id', pageflg); 
                formData.append('is_self', this.is_self);
               
                axios.post(this.$api_url_front+'/self/pf/loan/loan-delete', formData) 
                    .then(function (response) 
                    {    
                        this.$bvModal.hide('pause-modal'); 
                        this.$bvModal.hide('approve-modal');  
                        this.$bvModal.hide('decline-modal'); 
                        this.$bvModal.hide('unapprove-modal');
                        this.$bvModal.hide('delete-modal');
                        this.$bvModal.hide('withdraw-modal');
                        this.loan_entity_id=''; 
                        this.loan_update_status = '';
                        this.loading='';   
                        this.updateLoanData();
                    }.bind(this))
                    .catch(function (error) 
                    {
                        currentObj.showoverlay = false;
                        currentObj.serverError(error);
                    });
                            
            },
            withdrawLoan: function(pageflg)
            {
                
                console.log(pageflg);
                this.loading='load';
                let currentObj = this; 
                let formData = new FormData();
                formData.append('loan_id', pageflg); 
                formData.append('is_self', this.is_self);
               
                axios.post(this.$api_url+'/pf/loan/loan-withdraw', formData) 
                    .then(function (response) 
                    {    
                        this.$bvModal.hide('pause-modal'); 
                        this.$bvModal.hide('approve-modal');  
                        this.$bvModal.hide('decline-modal'); 
                        this.$bvModal.hide('unapprove-modal');
                        this.$bvModal.hide('delete-modal');
                        this.$bvModal.hide('withdraw-modal');
                        this.loan_entity_id=''; 
                        this.loan_update_status = '';
                        this.loading='';   
                        this.updateLoanData();
                        this.getLoanData();
                    }.bind(this))
                    .catch(function (error) 
                    {
                        currentObj.showoverlay = false;
                        currentObj.serverError(error);
                        console.log(error);
                    });
                            
            },
            
            getLoanEligible: function()
            {
    
                if(!this.checkNet()) return false; 
                let currentObj = this; 

                let formData = new FormData();
                formData.append('employee_id', this.employee_id); 
                axios.post(this.$api_url_front+'/pf/loan/eligible', formData) 
                .then(function (response) 
                {  
                    this.is_eligible = response.data.eligible;
                }.bind(this)).catch(function (error){currentObj.serverError(error);});

            },
            getLoanData: function()
            {
                this.updateTransactions();
                this.$bvModal.hide('bv-modal-loan');
                this.loan_title = 'Emloyee Advance List';
                if(!this.checkNet()) return false;
                let currentObj = this; 
                this.show_loader=true;
                
                let formData = new FormData();
                formData.append('employee_id', this.employee_id); 
               
                axios.post(this.$api_url+'/front/self/pf/loan/list', formData) 
                .then(function (response) 
                {  
                    this.loans = response.data;
                    //this.$emit('childToParent', value);
                    if(this.loans.length > 0)
                    {
                        this.e_name = this.loans[0].employee_name;
                        this.e_id = this.loans[0].employee_id;
                       
                    }
                    
                    this.show_loader=false;
                }.bind(this)).catch(function (error){currentObj.serverError(error);});

            },
            updateLoanData: function()
            {
                this.updateTransactions(); 
                this.$bvModal.hide('bv-modal-loan');
                this.loan_title = 'Emloyee Advance List';
                if(!this.checkNet()) return false;
                let currentObj = this; 
                
                let formData = new FormData();
                formData.append('employee_id', this.employee_id); 
               
                axios.post(this.$api_url+'/front/self/pf/loan/list', formData) 
                .then(function (response) 
                {  
                    this.loans = response.data;

                  
                }.bind(this)).catch(function (error){currentObj.serverError(error);});

            },
            validateState(ref)
            {
                if ( 
                    this.veeFields[ref] &&
                    (this.veeFields[ref].dirty || this.veeFields[ref].validated)
                ) {
                    return !this.veeErrors.has(ref);
                }
                return null;
            },
            updateTransactions()
            {
                if(!this.checkNet()) return false;
                let currentObj = this; 
                
                axios.get(this.$api_url_front+'/pf/loan/updatetransactions', {
                    params: {
                        loan_type: 1
                    }
                }).then(function(response){
                    this.$bvModal.hide('bv-modal-loan');
                }.bind(this)).catch(function (error){currentObj.serverError(error);});
                
            },
            addNewOld()
            {
                //alert(this.e_name);
                this.$bvModal.hide('show_terms');
                this.is_custom = 0;
                this.is_status= 0;
                this.loan_id = 0;
                this.count = this.count + 1;
                this.modal_title = "Process Pf Advance for " +this.e_name;
                this.$bvModal.show('bv-modal-loan-2');
                
            },
            addNew()
            { 
                this.curr_process_name = this.e_name;
                this.$bvModal.hide('show_terms');
                this.is_custom = 0;
                this.is_status= 0;
                this.loan_id = 0;
                this.count = this.count + 1;
                //this.modal_title = "Process Pf Advance for " +this.e_name;
                this.modal_title = "PF Advance Application";
                this.modal_title = "Process Advance for " +this.curr_process_name;
                this.$bvModal.show('bv-modal-loan');
                this.pf_loan_modal_class = 'pfloan-modal pf_new_loan_modal';
                
            },
            showStatementDownloadForm: function()
            {
                this.waiver_key += 1;
                this.showStatementForm = true;
                this.$bvModal.show('bv-modal-process-statement');
            },
			statementReturn()
            {
                this.showStatementForm = true;
                this.$bvModal.hide('bv-modal-process-statement');
            },
            // Start: Rejwan: 24-04-2025 2 decimal
			// formatMoney: function(amount)
            // {
            //     var money = Number(amount);
			// 	var dec_points = 0;

            //     if(this.$atl_company_number_format == 'no')
            //     {
            //         money = Math.round(money);
            //         money = money.toLocaleString();
            //     }
            //     else
            //     {
            //         money = money.toLocaleString();
            //         if(money=='NaN')
            //         money = amount;
            //         else
			// 		{
			// 			if(money.indexOf(".") < 0)
			// 			{
			// 				money = money+".00";
			// 			}
			// 			else
			// 			{
			// 				dec_points = money.length - money.indexOf('.') - 1;

			// 				if(dec_points == 1)
			// 				{
			// 					money = money+"0";
			// 				}
			// 				else if(dec_points == 0)
			// 				{
			// 					money = money+"00";
			// 				}
			// 			}

            //     	}
			// 	}
                
            //     return money;
            // }, 
            toMoney: function(amount){
                if(amount !="0")
                {
                    if(!isNaN(amount))
                    {
                        var number = Number(amount);
                        return number;
                    }
                var NumWithoutCommas = amount.replace(/,/g, ''); 
                var number = Number(NumWithoutCommas).toFixed(2);
                return number;
                }else
                    return amount;
            },
            replaceTableHeads(val){
                val = val.replace(/_/g, ' ');
                
                val = val.toLowerCase().split(' ');
                for(var i = 0; i < val.length; i++){
                    val[i] = val[i].charAt(0).toUpperCase() + val[i].substring(1);     
                }
                return val.join(' ');
            },
            editLoanInfoOld(loan_id,name,is_custom,status)
            {
                this.curr_process_name = name;
                this.curr_process_id = loan_id;
                this.modal_title = "Edit PF Advance";
                this.is_custom = is_custom;
                if(is_custom)
                {
                    this.modal_title = "Manual Payment";
                }
                if(this.curr_process_name.length >0)
                this.modal_title += " of "+this.curr_process_name;
                this.is_status= status;
                this.loan_id = loan_id;
                this.count = this.count + 1;
                this.$bvModal.show('bv-modal-loan-2');
            },
            editLoanInfo(loan_id,name,is_custom,status)
            {
                
                this.curr_process_name = name;
                this.curr_process_id = loan_id;
                this.modal_title = "Edit PF Advance Application";
                this.is_custom = is_custom;
                if(is_custom)
                {
                    this.modal_title = "Manual Payment";
                }
                if(this.curr_process_name.length >0)
                this.modal_title += " of "+this.curr_process_name;
                this.is_status= status;
                this.loan_id = loan_id;
                this.count = this.count + 1;
                this.pf_loan_modal_class = 'pfloan-modal'; 
                this.$bvModal.show('bv-modal-loan');

            },
            // Start: Rejwan: 08-04-2026 Early loan settlement
            earlySettlementDetails(loan_id,name,is_custom,status)
            {
                
                this.curr_process_name = name;
                this.curr_process_id = loan_id;
                this.modal_title = "PF Advance Early Settlement";
                
                if(this.curr_process_name.length >0)
                this.modal_title += " of "+this.curr_process_name;
                this.is_status= status;
                this.loan_id = loan_id;
                this.count = this.count + 1;
                this.pf_loan_modal_class = 'pfloan-modal'; 
                this.$bvModal.show('bv-modal-loan-early-settlement');

            },
            handleEarlySettlement()
            {
                this.$bvModal.hide('bv-modal-loan-early-settlement');
            },
            // End: Rejwan: 08-04-2026 Early loan settlement
            loanScheduleDetailsNew: function(employee_pf)
            { 
                if(employee_pf.employee_id>0){
                let currentObj = this;
                
                let formData = new FormData();
                formData.append('employee_id', employee_pf.employee_id); 
                formData.append('loan_id', employee_pf.id); 
                formData.append('viewmode', 1);
                formData.append('d_type', 'excel'); 
                this.pfoverlay = true;
                this.report_data = [];
                this.installments = [];
                this.transactions = [];
                this.employee_info = [];
                
                axios.post(this.$api_url_front + '/self/pf/schedule-report', formData)
                                    .then(function (response) 
                                    {

                                        
                                        this.report_data = response.data;
                                        this.employee_info = response.data.employee_info;
                                        this.installments = response.data.installments;
                                        this.transactions = response.data.transactions;
                                        this.pfoverlay = true;

                                        console.log(this.transactions);
                                    }.bind(this))
                                    .catch(function (error) 
                                    {
                                        console.log(error);
                                    }); 

                    }

                    this.$bvModal.show('bv-modal-pf-loan-schedule-details');

            }, 
            getloanScheduleReport: function(employee_pf)
            { 
                if(employee_pf.employee_id>0){
                    var curr_obj = this;
                    
                    let formData = new FormData();
                    formData.append('employee_id', employee_pf.employee_id); 
                    formData.append('loan_id', employee_pf.id); 
                    formData.append('d_type', 'excel'); 
                    this.loader = true;
                    // axios.post(this.$api_url + '/pf/schedule-report', formData)
                    //                     .then(function (response) 
                    //                     {
                    //                         this.loader = false;
                                            
                                            
                    //                         this.download_file(response.data);
                    //                     }.bind(this))
                    //                     .catch(function (error) 
                    //                     {
                    //                         console.log(error);
                    //                     }); 
                    this.downloadBlobResponse(
                        axios.post(this.$api_url_front + '/self/pf/schedule-report', formData, { responseType: 'blob' }),
                        'loader'
                    );

                }

            }, 
            stringView(str) 
            {
                var i, frags = str.split('_');
                for (i=0; i<frags.length; i++) {
                    frags[i] = frags[i].charAt(0).toUpperCase() + frags[i].slice(1);
                }
                return frags.join(' ');
            },
        },
        computed:
        {
            clickAccept()
            {

                if(this.accept == 'true')
                {
                    this.disableme = false;
                }
                else
                {
                    this.disableme = true;
                }
            },
        },
        created: function()
        {   
            this.getLoanEligible();
            this.getLoanData(); 
            this.getPFSettings();
        } ,
        
        
    }
</script> 
